export default {"src":"/_next/static/media/cds.30682e45.svg","height":70,"width":340,"blurWidth":0,"blurHeight":0};